import React from 'react';
import { Checkbox } from '../../UI';
import { getText } from '../../utils/functions';


const PortalOtherOptions = ({ localState, setLocalState, translate }) => {
	const sections = [];
	Object.keys(localState?.config?.optionalFields).forEach(
		section => {
			if (Object.keys(localState.config.optionalFields[section]).length > 0) {
				const options = [];
				Object.keys(localState?.config?.optionalFields[section]).forEach(
					option => options.push({
						name: option,
						value: localState?.config?.optionalFields[section][option],
						text: getText(localState.config.sections?.[option], translate),
					})
				);
				sections.push({
					name: section,
					text: getText(localState.config.sections?.[section], translate),
					options
				});
			}
		}
	);

	const onChange = (section, optionalSection, value) => {
		setLocalState({
			...localState,
			config: {
				...localState.config,
				optionalFields: {
					...localState.config.optionalFields,
					[section]: {
						...localState.config.optionalFields[section],
						[optionalSection]: value
					}
				}
			}
		});
	};

	return (
		<div style={{ marginBottom: '1em', width: '100%' }}>
			{sections
			&& sections.map(section => (
				<div key={section.name} style={{ marginBottom: '1em' }}>
					<h3 style={{
						fontSize: '1.1rem',
						fontStyle: 'italic',
						marginBottom: '0.2rem'
					}}>
						{section.text}
					</h3>
					{section.options.map(option => (
						<Checkbox
							key={`${section.name}_${option.name}`}
							label={`Activar ${option.text}`}
							value={option.value}
							onChange={(event, isInputChecked) => onChange(section.name, option.name, isInputChecked)}
						/>
					))}
				</div>))}
			{/* OTHER OPTIONS */}
			<h3
				style={{
					fontSize: '1.1rem',
					fontStyle: 'italic',
					marginBottom: '0.2rem'
				}}
			>
				Otras opciones
			</h3>
			<div style={{ marginBottom: '1rem' }}>
				<Checkbox
					label={'Enviar confirmaciones'}
					value={localState.sendAcceptConfirmation === 1}
					onChange={(event, isInputChecked) => {
						setLocalState({
							...localState,
							sendAcceptConfirmation: isInputChecked ? 1 : 0
						});
					}
					}
				/>
				<Checkbox
					label={'Enviar notificacion de rechazo'}
					value={localState.sendRefuseConfirmation === 1}
					onChange={(event, isInputChecked) => {
						setLocalState({
							...localState,
							sendRefuseConfirmation: isInputChecked ? 1 : 0
						});
					}
					}
				/>
			</div>
		</div>
	);
};

export default PortalOtherOptions;


